/** @jsx jsx */
import { jsx } from '@emotion/core'
import { FunctionComponent } from 'react'
import { styles } from './styles'

export const Placeholder: FunctionComponent = ({ children }) => (
  <div css={styles.container}>{children}</div>
)
